<template>
  <div class="is-flex align-center">
    <div
      :class="[`search-input-${appearance}`, `line-${lineHeight}`]"
      class="search-input-container flex-1"
    >
      <form @submit.prevent="handleSearch">
        <div
          class="search-input-bar"
        >
          <i
            v-if="withIcon"
            class="icon-lens"
          />
          <input
            v-model="query"
            :style="inputStyle"
            :placeholder="placeholder || $t('comps.SearchInput.placeholder')"
            :class="{'search-input--border': bordered,
                     'search-input--uppercased' : uppercased && query && query.length,
                     'search-input--shadow': shadow,
                     'search-input--cancel-btn': cancelButton
            }"
            class="search-input"
            type="text"
            @input="$emit('update:modelValue', $event.target.value)"
          >
          <IconButton
            v-if="cancelButton && query"
            :size="17"
            :padding="0"
            color="#9DAEB9"
            color-hover="#1F2935"
            background="transparent"
            icon="cancel"
            class="cancel-button"
            @click="$emit('update:modelValue', '')"
          />
        </div>
      </form>
    </div>
    <div
      v-if="withButton"
      class="has-margin-left-2"
    >
      <IconButton
        :size="17"
        :padding="7.5"
        background="#1784FB"
        color="white"
        icon="lens"
        @click="handleSearch"
      />
    </div>
  </div>
</template>

<script>

import IconButton from '@/components/buttons/IconButton.vue';

export default {
  name: 'SearchInput',
  components: {
    IconButton,
  },
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: null },
    bordered: { type: Boolean, default: false },
    withIcon: { type: Boolean, default: true },
    withButton: { type: Boolean, default: false },
    uppercased: { type: Boolean, default: false },
    inputStyle: { type: Object, default: () => null },
    lineHeight: {
      type: String,
      default: 'normal',
      validator: val => ['normal', 'small'].includes(val),
    },
    appearance: {
      type: String,
      default: 'primary',
      validator: val => ['primary', 'secondary', 'tertiary'].includes(val),
    },
    shadow: { type: Boolean, default: true },
    cancelButton: { type: Boolean, default: false },
  },
  // Vue 3: v-model → `modelValue` + `update:modelValue` (era `value` + `input`).
  emits: ['update:modelValue', 'searchSubmit'],
  data() {
    return {
      query: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.query = newVal;
    },
  },
  methods: {
    handleSearch() {
      this.$emit('searchSubmit', this.query);
    },
  },
};
</script>

<style lang="scss">

.search-input-container{
  height: 40px;

  &.search-input-secondary {
    .search-input-bar .icon-lens{
      position: absolute;
      z-index: 1;
      top: 12px;
      left: 10px;
      right: auto;
      color: $grey-gull;
    }
    .search-input-bar .search-input{
      padding-left: 30px;
      font-size: $size-9;
      border-radius: 5px;
      color: $blue-east-bay;
      &::placeholder{
        color: $grey-gull;
      }
      &--shadow {
        box-shadow: 0 0 10px 0 rgba(69,86,107,0.10);
      }
    }
  }
  &.search-input-tertiary {
    .search-input-bar .icon-lens{
      position: absolute;
      z-index: 1;
      top: 12px;
      left: 10px;
      right: auto;
      color: $grey-gull;
    }
    .search-input-bar .search-input{
      padding-left: 30px;
      font-size: $size-9;
      border: 1px solid $grey-border-dark;
      background-color: $white-old;
      border-radius: 5px;
      color: $blue-east-bay;
      &::placeholder{
        color: $grey-gull;
      }
    }
  }

  &.line-small {
    .search-input-bar .search-input {
      line-height: 30px;
    }
    .search-input-bar .icon-lens{
      top: 10px;
    }
  }
  .search-input-bar{
    position: relative;
  }
  .search-input-bar .icon-lens{
    position: absolute;
    z-index: 1;
    @include desktop {
      right: 10px;
      left: auto;
    }
    top: 10px;
    left: 10px;
    color: $grey-gull;
  }
  .search-input-bar .search-input{
    position: absolute;
    padding-left: 0.5rem;
    padding-right: 15px;
    width: 100%;
    line-height: 36px;
    border-radius: 10px;
    border: 1px solid transparent;
    background-color: $white;
    font-size: $size-6;
    &::placeholder{
      color: $blue-east-bay;
    }
    &:focus{
      outline: none;
    }
    &.search-input--border{
      border-color: $grey-pastel;
      padding-left: 30px;
    }
    &.search-input--uppercased {
      text-transform: uppercase;
    }
    &.search-input--cancel-btn {
      padding-right: 30px;
    }
  }
  .search-input-bar .cancel-button {
    position: absolute;
    z-index: 1;
    top: 12px;
    right: 10px;
    left: auto;
  }
}


</style>
